export default class PhotographerListImageTile {
    constructor($el, transitionDuration = 8000, offset = 0) {
        this.$el                = $el;
        this.transitionDuration = transitionDuration;
        this.offset             = offset;
        this.$images            = this.$el.querySelectorAll('img');

        if ( ! this.$images.length) {
            return;
        }

        this.$progressBar       = this.$el.querySelector('[data-photographer-list-tile-progress]');

        if (this.$images.length === 1 && this.$progressBar) {
            this.$el.querySelector('[data-photographer-list-tile-progress-wrap]')?.classList.add('no-display');
        }

        this.$activeImage       = this.$images[0];
        this.activeImageIndex   = 0;
        this.startedAt          = null;
        this.animationFrame     = null;

        this.showFirstImage     = this.showFirstImage.bind(this);
        this.start              = this.start.bind(this);
        this.update             = this.update.bind(this);

        if (this.$activeImage.complete && this.$activeImage.naturalWidth > 0) {
            this.showFirstImage();
        } else {
            this.$activeImage.addEventListener('load', this.showFirstImage, {once: true});
        }
    }

    /**
     * Reveal the first image as soon as it has loaded
     */
    showFirstImage() {
        this.$el.classList?.add('loaded');
        this.$activeImage?.classList.remove('hidden');
        this.updateProgressBar(0);

        if (this.$images.length > 1) {
            this.$el.classList?.add('no-fade');
            setTimeout(this.start, this.offset);
        }
    }

    /**
     * Start the image rotation and progress bar from the same JS clock
     */
    start() {
        if (this.startedAt !== null) {
            return;
        }

        this.startedAt = performance.now();
        this.animationFrame = requestAnimationFrame(this.update);

        this.$el.classList?.remove('no-fade');
    }

    /**
     * Update the active image and progress bar
     */
    update(timestamp) {
        const elapsed = timestamp - this.startedAt;
        const progress = elapsed / this.transitionDuration;
        const imageIndex = Math.floor(progress) % this.$images.length;

        if (imageIndex !== this.activeImageIndex) {
            this.showImage(imageIndex);
        }

        this.updateProgressBar(progress % 1);
        this.animationFrame = requestAnimationFrame(this.update);
    }

    /**
     * Show the image at the requested index
     */
    showImage(imageIndex) {
        const nextImage = this.$images[imageIndex];

        this.$activeImage?.classList.add('hidden');
        this.$activeImage = nextImage;
        this.activeImageIndex = imageIndex;
        this.$activeImage?.classList.remove('hidden');
    }

    /**
     * Set progress bar position
     */
    updateProgressBar(progress) {
        if ( ! this.$progressBar) {
            return;
        }

        this.$progressBar.style.transform = `scaleX(${progress})`;
    }
}
